import React from 'react'
import styled from 'styled-components'
import convertHexToRGBA from '../../../helpers/HexToRgba'

import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const ScheduledPricesManagerTransmissionStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => convertHexToRGBA(props.colorCode, 0.2)};
	color: ${(props) => props.colorCode};
	line-height: 32px;
	font-weight: bold;
	width: fit-content;
	padding: 0 10px;
	border-radius: 15px;
	margin: 0 auto;
`
//////STYLED//////

const ScheduledPricesManagerTransmissionStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	return (
		<ScheduledPricesManagerTransmissionStatusWrapper
			colorCode={props.row.transmitionStatus?.colorCode || props.row.transmissionStatus?.colorCode}
		>
			{translations[props.row.transmitionStatus?.translationKey] || translations[props.row.transmissionStatus?.translationKey]}
		</ScheduledPricesManagerTransmissionStatusWrapper>
	)
}

ScheduledPricesManagerTransmissionStatus.propTypes = {}

ScheduledPricesManagerTransmissionStatus.defaultPropTypes = {}

export default ScheduledPricesManagerTransmissionStatus
